export default __webpack_public_path__ + "/Tick-DeepFrozenApps-397275646.mp3";